<template>
  <section class="advise">
    <div class="advise__media">
      <picture>
        <source media="(max-width: 768px)" :srcset="conceptsMobileImage" />
        <source media="(max-width: 1024px)" srcset="../../../assets/bienvenida_advise_tablet.webp" />
        <img
          :src="conceptsDesktopImage"
          alt="Sala acogedora"
          class="advise__image"
        />
      </picture>
    </div>

    <div class="advise__content">
      <DsChip label="Lo que necesitas saber" variant="orange" />

      <div class="advise__title">
        <DsTextSplit
          as="h4"
          class="section-title_bebas"
          base="Conceptos clave"
          highlight="para tu proceso"
          base-color="var(--ds-purple-400)"
          highlight-color="var(--ds-purple-900)"
        />
      </div>

      <DsText as="body3" class="advise__intro">
        Tu camino está dividido en etapas claras.<br />
        Aquí puedes entender en cuál estás y qué sigue:
      </DsText>

      <div class="advise__grid">
        <article v-for="item in items" :key="item.title" class="advise__card">
          <DsText as="subtitle7" color="var(--ds-secondary-main)">{{ item.title }}</DsText>
          <DsText as="body3" font-family="var(--ds-font-family-inter)" class="advise__copy">{{ item.description }}</DsText>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import DsChip from '../atoms/DsChip.vue'
import DsText from '../atoms/DsText.vue'
import DsTextSplit from '../atoms/DsTextSplit.vue'
import conceptsMobileImage from '../../../assets/bienvenida-mobile/conceptos.png'
import conceptsDesktopImage from '../../../assets/bienvenida-desktop-conceptos.png'

const items = [
  {
    title: 'Autofinanciamiento',
    description:
      'Tu grupo aporta a un fondo común que permite que los integrantes obtengan su vivienda.',
  },
  {
    title: 'Cuota periódica',
    description: 'Tu pago incluye tu aportación y costos administrativos.',
  },
  {
    title: 'Factor de actualización',
    description: 'Permite que tu financiamiento mantenga su valor en el tiempo.',
  },
  {
    title: 'Adjudicación',
    description: 'Por pagos al corriente, antigüedad, liquidación anticipada o situaciones especiales.',
  },
]
</script>

<style scoped>
.advise {
  display: grid;
  grid-template-columns: minmax(0, 0.98fr) minmax(0, 1.42fr);
  gap: 22px;
}

.advise__media {
  border-radius: 28px;
  overflow: hidden;
  min-height: 590px;
}

.advise__media picture {
  display: block;
  width: 100%;
  height: 100%;
}

.advise__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.advise__content {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-top: 8px;
}

.advise__title {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.advise__intro {
  color: var(--ds-text-primary);
  line-height: 1.45;
  max-width: 760px;
}

.advise__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 28px 18px;
  margin-top: 8px;
}

.section-title_bebas {
  font-family: var(--ds-font-family-bebas);
}

.advise__card {
  min-height: 180px;
  border-radius: 28px;
  background: #ffffff;
  box-shadow: 0 20px 40px rgba(47, 45, 116, 0.03);
  border: 1px solid rgba(47, 45, 116, 0.03);
  padding: 24px 12px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.advise__copy {
  color: var(--ds-text-primary);
  line-height: 1.35;
  max-width: 280px;
}

@media (max-width: 1024px) {
  .advise {
    grid-template-columns: 1fr;
    width: 100%;
    justify-self: center;
  }

  .advise__media {
    min-height: 420px;
  }
}

@media (min-width: 1025px) {
  .advise { grid-template-columns: 410px 528px; gap: 24px; min-height: 576px; }
  .advise__media { min-height: 576px; border-radius: 24px; }
  .advise__image { border-radius: 24px; }
  .advise__content { gap: 32px; padding: 0; }
  .advise__title { margin-bottom: -24px; }
  .advise__intro { line-height: 24px; }
  .advise__grid { gap: 24px; margin-top: 0; }
  .advise__card {
    min-height: 176px;
    border: 0;
    border-radius: 24px;
    box-shadow: none;
    padding: 24px 16px;
    gap: 8px;
    box-sizing: border-box;
  }
  .advise__copy { line-height: 24px; }
}

@media (max-width: 768px) {
  .advise {
    grid-template-columns: 1fr;
    width: 100%;
    justify-self: center;
    gap: 32px;
  }

  .advise__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .advise__media {
    height: 462px;
    min-height: 462px;
    border-radius: 24px;
  }

  .advise__content { gap: 32px; }

  .advise__card {
    min-width: 0;
    border-radius: 24px;
    overflow-wrap: anywhere;
  }
}
</style>
